import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import app from './modules/app'
import menu from './modules/menu'
import user from './modules/userinfo'

import * as getters from './getters'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  getters,
  modules: {
    auth,
    app,
    menu,
    user
  },
  state: {},
  mutations: {},
  plugins: [createPersistedState()]
})

Vue.use(store)

export default store
